import moment from "moment";
import Swal from 'sweetalert2';
import {showSuccess, showWarning} from "./notification.utils";

export const utcDateToLocal = (date) => {
  const fmt = 'YYYY-MM-DDTHH:mm:ss';
  return moment.utc(date, fmt).local().format('YYYY-MM-DD, HH:mm');
}

export const toLocalDate = (date) => {
  const fmt = 'YYYY-MM-DDTHH:mm:ss';
  return moment.utc(date, fmt).local().format('YYYY-MM-DD');
}

export const formatSlotTime = (dateTimeString) => {
  // Convert UTC time to user's local timezone
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return moment.utc(dateTimeString).tz(userTimezone).format('HH:mm');
}

export const utcDateToLocalDate = (date) => {
  let locale = Intl.NumberFormat().resolvedOptions().locale
  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return Date(date).toLocaleString(locale, {
    timeZone,
  });
}

export const generateUUID = () => {
  return `${Date.now().toString(36)}-${Math.random().toString(36).substr(2, 9)}`;
}

export const generateIdempotencyKey = () => {
  return `${Date.now().toString(36)}-${Math.random().toString(36).substr(2, 9)}`;
}

export const convertToLocalDate = (utcDate, utcTime) => {
  if (utcDate && utcTime) {
    const local = moment.utc(utcDate + ' ' + utcTime).local().format('YYYY-MM-DD HH:mm:ss');
    return moment(local).local().format('YYYY-MM-DD');
  }
}

export const convertToLocalTime = (utcDate, utcTime) => {
  if (utcDate && utcTime) {
    const local = moment.utc(utcDate + ' ' + utcTime).local().format('YYYY-MM-DD HH:mm:ss');
    return moment(local).local().format('HH:mm');
  }
}

export function toFilename(name) {
  if (!name || !name.trim()) {
    return 'unknown_customer';
  }

  return name
    .trim()
    .replace(/[^a-zA-Z0-9]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase();
}

export const enumToHumanReadable = (enumValue) => {
  if (!enumValue) {
    return '-'
  }
  return enumValue
    .toLowerCase()
    .split('_')
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
}

export function getCurrentDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`
}

export function getDefaultTime() {
  const date = new Date();
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const seconds = date.getSeconds().toString().padStart(2, '0')
  return `${hours}:${minutes}:${seconds}`
}

export function addDaysToDateLegacy(dateString, daysToAdd) {
  const date = new Date(dateString);

  if (isNaN(date)) {
    console.warn("Invalid date format");
    return null;
  }

  date.setDate(date.getDate() + daysToAdd);

  return date.toISOString().slice(0, 19).replace("T", " ");
}

export function addDaysToDate(dateString, daysToAdd) {
  return moment(dateString).add(daysToAdd, 'days').format("YYYY-MM-DD HH:mm:ss");
}

export function maskPhoneNumber(phoneNumber) {
  if (typeof phoneNumber !== 'string' || phoneNumber.length < 8) {
    return;
  }

  const firstFive = phoneNumber.slice(0, 5);
  const lastThree = phoneNumber.slice(-3);
  const maskedSection = '*'.repeat(phoneNumber.length - 8);

  return `${firstFive}${maskedSection}${lastThree}`;
}

export function maskEmail(email) {
  if (typeof email !== 'string' || !email.includes('@')) {
    return;
  }

  const [localPart, domainPart] = email.split('@');
  if (localPart.length < 3) {
    return
  }

  const firstTwoChars = localPart.slice(0, 2);
  const maskedLocal = firstTwoChars + '*'.repeat(localPart.length - 2);
  const domain = domainPart.split('.');
  const domainName = domain[0];
  const topLevelDomain = domain.slice(1).join('.');

  return `${maskedLocal}@${domainName}.${topLevelDomain}`;
}

export function getCurrencySymbol(currencyCode) {
  const locale = getBrowserLocale();
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  });

  const parts = formatter.formatToParts(1);
  console.log(parts.find(part => part.type === 'currency').value);
  return parts.find(part => part.type === 'currency').value;
}

export function getBrowserLocale() {
  return navigator.language || (navigator.languages && navigator.languages[0]) || 'en-US';
}

export function getFullName(firstName, lastName) {
  if (firstName !== null && lastName !== null) {
    return `${firstName} ${lastName}`;
  } else if (firstName !== null && lastName === null) {
    return firstName;
  } else if (firstName === null && lastName !== null) {
    return lastName;
  } else {
    return 'Unknown';
  }
}

export function extractFullName(contact) {
  return getFullName(contact.firstName, contact.lastName)
}

export function formatFileSize(size) {
  if (!size) {
    return 0;
  }
  const units = ["B", "KB", "MB", "GB"];
  let unitIndex = 0;
  let formattedSize = size;

  while (formattedSize >= 1024 && unitIndex < units.length - 1) {
    formattedSize /= 1024;
    unitIndex++;
  }
  return `${formattedSize.toFixed(2)} ${units[unitIndex]}`;
}

export function validateFileSize(file) {
  const maxSize = 10 * 1024 * 1024; // 10 MB
  if (file.size > maxSize) {
    alert("File size exceeds the maximum limit of 10 MB.");
    return false;
  }
  return true;
}

export function toSentenceCase(str) {
  if (!str) return '';
  str = str.trim();
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}


export const invoiceTabs = [
  {
    key: 'invoices',
    label: 'Invoices',
    translationKey: 'sidebar.invoices',
    route: '/invoices',
    requiredPermission: 'INVOICE_CREATE',
    module: 'invoices',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor']
  },
  {
    key: 'recurring-invoices',
    translationKey: 'sidebar.recurringInvoices',
    route: '/recurring-invoices',
    requiredPermission: 'INVOICE_CREATE',
    module: 'recurringInvoices',
    industries: ['levies', 'medical', 'school', 'commerce', 'contractor']
  },
  {
    key: 'bill-runs',
    translationKey: 'sidebar.billRuns',
    route: '/billing/bill-runs',
    requiredPermission: 'INVOICE_CREATE',
    module: 'bills',
    industries: ['levies', 'school']
  },
  {
    key: 'creditNotes',
    label: 'Credit Notes',
    translationKey: 'sidebar.creditNotes',
    route: '/credit-notes',
    requiredPermission: 'INVOICE_CREATE',
    module: 'creditNotes',
    industries: ['commerce'],
    hidden: true
  },
  {
    key: 'debitNotes',
    label: 'Debit Notes',
    translationKey: 'sidebar.debitNotes',
    route: '/debit-notes',
    requiredPermission: 'INVOICE_CREATE',
    module: 'debitNotes',
    industries: ['commerce'],
    hidden: true
  },
]

export const statementTabs = [
  {
    key: 'statement-runs',
    translationKey: 'sidebar.statementRuns',
    route: '/statements/runs',
    requiredPermission: 'INVOICE_CREATE',
    module: 'billing',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor'],
    active: true
  },
  {
    key: 'statements',
    label: 'Statements',
    translationKey: 'sidebar.statements',
    route: '/statements/logs',
    requiredPermission: 'INVOICE_CREATE',
    module: 'billing',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor'],
    active: true
  },
  {
    key: 'recurring-statements',
    translationKey: 'sidebar.recurringStatements',
    route: '/statements/recurring-statements',
    requiredPermission: 'STATEMENT_READ',
    module: 'recurringStatements',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor'],
    active: false
  },
]

export const paymentTabs = [
  {
    key: 'payments',
    label: 'Payments',
    translationKey: 'sidebar.payments',
    route: '/receipts',
    requiredPermission: 'INVOICE_CREATE',
    module: 'receipts',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor'],
    active: true
  },
  {
    key: 'online-payments',
    translationKey: 'sidebar.onlinePayments',
    route: '/payments',
    requiredPermission: 'INVOICE_CREATE',
    module: 'receipts',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor'],
    active: true
  },
]

export const claimTabs = [
  {
    key: 'claims',
    label: 'Claims',
    translationKey: 'sidebar.claims',
    route: '/claims',
    requiredPermission: 'INVOICE_CREATE',
    module: 'receipts',
    industries: ['medical', 'commerce'],
    active: true
  },
  {
    key: 'claim-remittance',
    translationKey: 'sidebar.claimRemittances',
    route: '/claim-remittances',
    requiredPermission: 'INVOICE_CREATE',
    module: 'receipts',
    industries: ['medical'],
    active: true
  },
  {
    key: 'medical-aids',
    translationKey: 'sidebar.medicalAids',
    route: '/medical-aids',
    requiredPermission: 'INVOICE_CREATE',
    module: 'receipts',
    industries: ['medical'],
    active: true
  },
  {
    key: 'medical-aid-balances',
    translationKey: 'sidebar.medicalAidBalances',
    route: '/medical-aid-balances',
    requiredPermission: 'INVOICE_CREATE',
    module: 'receipts',
    industries: ['medical'],
    active: true
  },
]

export const communicationTabs = [
  {
    key: 'communication-logs',
    label: 'Communication Logs',
    translationKey: 'sidebar.communicationLogs',
    route: '/communication-logs',
    requiredPermission: 'INVOICE_CREATE',
    module: 'reports',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor'],
    active: true
  },
  {
    key: 'communications',
    label: 'Communications',
    translationKey: 'sidebar.communications',
    route: '/communications',
    requiredPermission: 'INVOICE_CREATE',
    module: 'reports',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor'],
    active: true
  },
]

export const purchasesTabs = [
  {
    key: 'rfq',
    label: 'RFQs',
    translationKey: 'sidebar.rfd',
    route: '/rfq',
    requiredPermission: 'RFQ_READ',
    module: 'rfq',
    hidden: true,
  },
  {
    key: 'supplierQuotations',
    label: 'Vendor Quotations',
    translationKey: 'sidebar.supplierQuotations',
    route: '/supplier-quotations',
    requiredPermission: 'SUPPLIER_QUOTATIONS_READ',
    module: 'supplierQuotations',
    hidden: true,
  },
  {
    key: 'purchaseOrders',
    label: 'Purchase Orders',
    translationKey: 'sidebar.purchaseOrders',
    route: '/purchase-orders',
    requiredPermission: 'PURCHASE_ORDERS_READ',
    module: 'purchaseOrders',
    hidden: true,
  },
  {
    key: 'grv',
    label: 'GRVs',
    translationKey: 'sidebar.grv',
    route: '/goods-received-voucher',
    requiredPermission: 'GRV_READ',
    module: 'grv',
    hidden: true,
  },
  {
    key: 'expenses',
    label: 'Expenses',
    translationKey: 'sidebar.expenses',
    route: '/expenses',
    requiredPermission: 'EXPENSES_READ',
    module: 'expenses',
    hidden: false,
  },
  {
    key: 'bills',
    label: 'Bills',
    translationKey: 'sidebar.bills',
    route: '/bills',
    requiredPermission: 'INVOICES_READ',
    module: 'bills1',
    hidden: true,
  },
  {
    key: 'cashPurchases',
    label: 'Purchases',
    translationKey: 'purchases.cashPurchases',
    route: '/cash-purchases',
    requiredPermission: 'INVOICES_READ',
    module: 'cashPurchases1',
    hidden: true,
  },
  {
    key: 'suppliers',
    label: 'Vendors',
    translationKey: 'sidebar.suppliers',
    route: '/suppliers',
    requiredPermission: 'SUPPLIERS_READ',
    module: 'suppliers',
    hidden: true,
  },
]

export const viewQuotationTabs = (id) => {
  return [
    {
      key: 'view-quotation',
      label: 'Quotation',
      translationKey: 'sidebar.quotation',
      route: `/quotations/${id}`,
      requiredPermission: 'QUOTATION_READ',
      module: 'quotations',
    },
    {
      key: 'view-quotation-pdf',
      label: 'View PDF',
      translationKey: 'sidebar.quotation',
      route: `/quotations/${id}/pdf`,
      requiredPermission: 'QUOTATION_READ',
      module: 'quotations',
    },
  ]
}

export const viewOrderTabs = (id) => {
  return [
    {
      key: 'view-order',
      label: 'Order',
      translationKey: 'sidebar.order',
      route: `/orders/${id}`,
      requiredPermission: 'ORDER_READ',
      module: 'orders',
    },
    {
      key: 'view-order-pdf',
      label: 'View PDF',
      translationKey: 'sidebar.order',
      route: `/orders/${id}/pdf`,
      requiredPermission: 'ORDER_READ',
      module: 'orders',
    },
  ]
}

export const viewInvoiceTabs = (id) => {
  return [
    {
      key: 'view-invoice',
      label: 'Invoice',
      translationKey: 'sidebar.invoice',
      route: `/invoices/${id}`,
      requiredPermission: 'INVOICE_READ',
      module: 'invoices',
    },
    {
      key: 'view-invoice-pdf',
      label: 'View PDF',
      translationKey: 'sidebar.invoice',
      route: `/invoices/${id}/pdf`,
      requiredPermission: 'INVOICE_READ',
      module: 'invoices',
    },
  ]
}

export const contactTypes = [
  {key: 'OWNER', value: 'Owner', industries: ['levies']},
  {key: 'TENANT', value: 'Tenant', industries: ['levies']},
  {key: 'CABIN_MASTER', value: 'Cabin Master', industries: ['levies']},
  {key: 'MOTHER', value: 'Mother', industries: ['school']},
  {key: 'FATHER', value: 'Father', industries: ['school']},
  {key: 'GUARDIAN', value: 'Guardian', industries: ['school']},
  {
    key: 'OTHER',
    value: 'Other',
    industries: ['levies', 'medical', 'school', 'commerce', 'personal', 'contractor', 'fastatext']
  }
];

export function visibleTabs(tabs, permissions, modules, context = {}) {
  const {locale, component} = context;

  return tabs.filter(tab => {
    // Check permissions
    if (tab.requiredPermission && !permissions[tab.requiredPermission]) return false;

    // Check module availability
    if (tab.module && !modules.includes(tab.module)) return false;

    // Check locale
    if (tab.locale && tab.locale !== locale) return false;

    // Custom visibility condition
    if (typeof tab.visible === 'function' && !tab.visible(component)) return false;

    return true;
  });
}

export function confirmAndDelete({
                                   title = 'Are you sure?',
                                   text = "You won't be able to revert this!",
                                   confirmButtonText = 'Yes, delete it!',
                                   deleteFn,
                                   successMessage = 'Successfully deleted',
                                   onSuccess,
                                   onFailure,
                                   router,
                                   redirectTo,
                                 }) {
  Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText
  }).then(result => {
    if (result.isConfirmed) {
      deleteFn()
        .then(response => {
          if (response.data && response.data.success) {
            showSuccess(successMessage);
            if (onSuccess) onSuccess(response);
            if (redirectTo && router) router.push(redirectTo);
          } else {
            const msg = response.data && response.data.narrative || 'Operation failed';
            showWarning(msg);
            if (onFailure) onFailure(response);
          }
        })
        .catch(e => handleError(e));
    }
  });
}


export const viewCustomerTabs = (id) => {
  return [
    {
      key: 'customer-personal-details',
      translationKey: 'sidebar.personalDetailsTabTitle',
      route: `/customers/${id}/personal-details`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'invoices',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-appointments',
      label: 'Appointments',
      translationKey: 'sidebar.appointments',
      route: `/customers/${id}/appointments`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'appointments',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-invoices',
      label: 'Invoices',
      translationKey: 'sidebar.invoices',
      route: `/customers/${id}/invoices`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'invoices', // Replace with actual module if needed
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-receipts',
      label: 'Payments',
      translationKey: 'sidebar.receipts',
      route: `/customers/${id}/receipts`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'receipts',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-payments',
      label: 'Payments',
      translationKey: 'sidebar.receipts',
      route: `/customers/${id}/payments`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'dummyModule',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-invoices',
      label: 'Invoices',
      translationKey: 'sidebar.invoices',
      route: `/customers/${id}/billing/invoices`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'dummyModule',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-visits',
      translationKey: 'sidebar.visits',
      route: `/customers/${id}/appointments`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'visits',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-payment-methods',
      label: 'Payment Methods',
      translationKey: 'sidebar.paymentMethods',
      route: `/customers/${id}/payment-methods`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'dummyModule',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-contact-details',
      label: 'Contact Details',
      translationKey: 'sidebar.contactDetails',
      route: `/customers/${id}/contact-details/addresses`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'dummyModule',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-clinical-details',
      label: 'Clinical Details',
      translationKey: 'sidebar.clinicalDetails',
      route: `/customers/${id}/clinical-details/complaints`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'medical',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-documents',
      label: 'Documents',
      translationKey: 'sidebar.documents',
      route: `/customers/${id}/documents`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'documents',
      tabGroup: 'customer-details',
    },
    {
      key: 'contact-basic-details',
      translationKey: 'sidebar.contactDetailsTabTitle',
      route: `/contacts/${id}/basic-details`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'invoices',
      tabGroup: 'contact-details',
    },
    {
      key: 'customer-claims',
      translationKey: 'sidebar.claims',
      route: `/customers/${id}/claims`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'claims',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-medical-aid-policies',
      translationKey: 'sidebar.medicalAidPolicies',
      route: `/customers/${id}/medical-aid-policies`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'claims',
      tabGroup: 'customer-details',
    },
    {
      key: 'customer-relationships',
      translationKey: 'sidebar.owners',
      route: `/customers/${id}/relationships`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'invoices',
      tabGroup: 'customer-details',
    },
    {
      key: 'contact-relationships',
      translationKey: 'sidebar.customers',
      route: `/contacts/${id}/relationships`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'invoices',
      tabGroup: 'contact-details',
    },
    {
      key: 'customer-groups',
      translationKey: 'customer.groups',
      route: `/customers/${id}/groups`,
      requiredPermission: 'CUSTOMER_READ',
      module: 'invoices',
      tabGroup: 'customer-details',
    },
  ]
}

export function formatDateForInput(dateString) {
  if (!dateString) return '';
  // Assuming dateString is in a format that moment can parse, like 'YYYY-MM-DD' or a full ISO string.
  // The <input type="date"> requires 'YYYY-MM-DD'.
  return moment(dateString).format('YYYY-MM-DD');
}



// WEBPACK FOOTER //
// ./src/utils/utils.js